import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  getRequiredDocuments(applicationId) {
    return RetailerApiClient.get(`applications/${applicationId}/required-documents`)
      .then(response => response)
      .catch(err => {
        throw err
      })
  },
  checkApplicationDocuments(applicationId) {
    return RetailerApiClient.get(`applications/${applicationId}/check-application-documents`)
      .then(response => response)
      .catch(err => {
        throw err
      })
  },
  getPublicQrCode(applicationId) {
    return RetailerApiClient.get(`applications/${applicationId}/public-upload-document-qr`)
      .then(response => response)
      .catch(err => {
        throw err
      })
  },
  sendUploadDocumentSMStoFarmer(applicationId) {
    return RetailerApiClient.get(`applications/${applicationId}/send-upload-documents-sms-to-farmer`)
      .then(response => response)
      .catch(err => {
        throw err
      })
  },
  getPublicUploadKYCDocumentQr(applicationId) {
    return RetailerApiClient.get(`applications/${applicationId}/get-upload-kyc-document-qr-image`)
      .then(response => response)
      .catch(err => {
        throw err
      })
  },
  sendUploadKYCDocumentSMStoFarmer(applicationId) {
    return RetailerApiClient.get(`applications/${applicationId}/send-upload-kyc-document-sms-to-farmer`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  uploadDocument(applicationId, formData) {
    return RetailerApiClient.postForm(`applications/${applicationId}/upload-document`, formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  viewRequiredDocument(applicationId, document, mimeType) {
    return RetailerApiClient.get(`applications/${applicationId}/documents/${document.id}`, {
      responseType: 'arraybuffer'
    })
      .then(response => {
        let blob = new Blob([response], { type: mimeType })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  uploadKycDocument(applicationId, document) {
    return RetailerApiClient.postForm(`applications/${applicationId}/upload-kyc-document`, document)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  transition(id, target_state) {
    return RetailerApiClient.post('applications/' + id + '/transition', {
      target_state: target_state
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  sendDigitalSignatureSmsToFarmer(applicationId, documentId) {
    return RetailerApiClient.post(`applications/${applicationId}/documents/${documentId}/send-digital-signature-sms-to-farmer`)
      .then(response => response)
      .catch(err => {
        throw err
      })
  },
  verifyDigitalSignature(applicationId, documentId, code) {
    return RetailerApiClient.post(`applications/${applicationId}/documents/${documentId}/verify-digital-signature`, { code })
      .then(response => response)
      .catch(err => {
        throw err
      })
  }
}
